import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const OfficeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 20 20">
    <path
      d="M11.6667 7.57501L19.0083 9.03335C19.6 9.15835 20 9.65835 20 10.25V18.75C20 19.4417 19.4417 20 18.75 20H11.25C11.4833 20 11.6667 19.8167 11.6667 19.5833V19.1667H18.75C18.975 19.1667 19.1667 18.9833 19.1667 18.75V10.25C19.1667 10.0583 19.0333 9.88335 18.8417 9.84168L11.6667 8.42501V7.57501Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M16.2498 11.6667C16.4832 11.6667 16.6665 11.85 16.6665 12.0834C16.6665 12.3167 16.4832 12.5 16.2498 12.5H14.5832C14.3498 12.5 14.1665 12.3167 14.1665 12.0834C14.1665 11.85 14.3498 11.6667 14.5832 11.6667H16.2498Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M16.2498 14.1667C16.4832 14.1667 16.6665 14.35 16.6665 14.5834C16.6665 14.8167 16.4832 15 16.2498 15H14.5832C14.3498 15 14.1665 14.8167 14.1665 14.5834C14.1665 14.35 14.3498 14.1667 14.5832 14.1667H16.2498Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M16.2498 16.6667C16.4832 16.6667 16.6665 16.85 16.6665 17.0834C16.6665 17.3167 16.4832 17.5 16.2498 17.5H14.5832C14.3498 17.5 14.1665 17.3167 14.1665 17.0834C14.1665 16.85 14.3498 16.6667 14.5832 16.6667H16.2498Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M11.6668 19.5833C11.6668 19.8167 11.4835 20 11.2502 20C11.0168 20 10.8335 19.8167 10.8335 19.5833V19.1667V7.91666C10.8335 7.79166 10.8918 7.675 10.9835 7.59166C11.0835 7.51666 11.2085 7.48333 11.3335 7.50833L11.6668 7.575V8.425V19.1667V19.5833Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M10.8332 19.1667V19.5834C10.8332 19.8167 11.0165 20 11.2498 20H7.9165C8.14984 20 8.33317 19.8167 8.33317 19.5834V19.1667H10.8332Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M8.74984 4.16669C8.98318 4.16669 9.16651 4.35002 9.16651 4.58335C9.16651 4.81669 8.98318 5.00002 8.74984 5.00002H7.08317C6.84984 5.00002 6.6665 4.81669 6.6665 4.58335C6.6665 4.35002 6.84984 4.16669 7.08317 4.16669H8.74984Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M9.16651 7.08335C9.16651 7.31669 8.98318 7.50002 8.74984 7.50002H7.08317C6.84984 7.50002 6.6665 7.31669 6.6665 7.08335C6.6665 6.85002 6.84984 6.66669 7.08317 6.66669H8.74984C8.98318 6.66669 9.16651 6.85002 9.16651 7.08335Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M9.16651 7.08335C9.16651 7.31669 8.98318 7.50002 8.74984 7.50002H7.08317C6.84984 7.50002 6.6665 7.31669 6.6665 7.08335C6.6665 6.85002 6.84984 6.66669 7.08317 6.66669H8.74984C8.98318 6.66669 9.16651 6.85002 9.16651 7.08335Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M8.74984 9.16669C8.98318 9.16669 9.16651 9.35002 9.16651 9.58335C9.16651 9.81669 8.98318 10 8.74984 10H7.08317C6.84984 10 6.6665 9.81669 6.6665 9.58335C6.6665 9.35002 6.84984 9.16669 7.08317 9.16669H8.74984Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M8.74984 11.6667C8.98318 11.6667 9.16651 11.85 9.16651 12.0834C9.16651 12.3167 8.98318 12.5 8.74984 12.5H7.08317C6.84984 12.5 6.6665 12.3167 6.6665 12.0834C6.6665 11.85 6.84984 11.6667 7.08317 11.6667H8.74984Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M5 12.0834C5 12.3167 4.81667 12.5 4.58333 12.5H2.91667C2.68333 12.5 2.5 12.3167 2.5 12.0834C2.5 11.85 2.68333 11.6667 2.91667 11.6667H4.58333C4.81667 11.6667 5 11.85 5 12.0834Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M4.58333 4.16669C4.81667 4.16669 5 4.35002 5 4.58335C5 4.81669 4.81667 5.00002 4.58333 5.00002H2.91667C2.68333 5.00002 2.5 4.81669 2.5 4.58335C2.5 4.35002 2.68333 4.16669 2.91667 4.16669H4.58333Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M4.58333 6.66669C4.81667 6.66669 5 6.85002 5 7.08335C5 7.31669 4.81667 7.50002 4.58333 7.50002H2.91667C2.68333 7.50002 2.5 7.31669 2.5 7.08335C2.5 6.85002 2.68333 6.66669 2.91667 6.66669H4.58333Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M4.58333 9.16669C4.81667 9.16669 5 9.35002 5 9.58335C5 9.81669 4.81667 10 4.58333 10H2.91667C2.68333 10 2.5 9.81669 2.5 9.58335C2.5 9.35002 2.68333 9.16669 2.91667 9.16669H4.58333Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M7.50016 15.4167C7.50016 15.1834 7.3085 15 7.0835 15H4.5835C4.35016 15 4.16683 15.1834 4.16683 15.4167V19.1667H3.3335V15.4167C3.3335 14.725 3.89183 14.1667 4.5835 14.1667H7.0835C7.77516 14.1667 8.3335 14.725 8.3335 15.4167V19.1667H7.50016V15.4167Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M4.16683 19.1667H7.50016H8.3335V19.5834C8.3335 19.8167 8.15016 20 7.91683 20H3.75016C3.51683 20 3.3335 19.8167 3.3335 19.5834V19.1667H4.16683Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
    <path
      d="M1.45833 0.166676L10.6167 1.55834C11.225 1.65834 11.6667 2.17501 11.6667 2.79168V7.57501L11.3333 7.50834C11.2083 7.48334 11.0833 7.51668 10.9833 7.59168C10.8917 7.67501 10.8333 7.79168 10.8333 7.91668V2.79168C10.8333 2.58334 10.6833 2.40834 10.4833 2.37501L1.325 0.991676C1.3 0.983343 1.275 0.983343 1.25 0.983343C1.15 0.983343 1.05833 1.01668 0.983333 1.08334C0.883333 1.16668 0.833333 1.27501 0.833333 1.40001V18.75C0.833333 18.9833 1.025 19.1667 1.25 19.1667H3.33333V19.5833C3.33333 19.8167 3.51667 20 3.75 20H1.25C0.558333 20 0 19.4417 0 18.75V1.40001C0 1.03334 0.158333 0.683343 0.441667 0.450009C0.725 0.208343 1.09167 0.108342 1.45833 0.166676Z"
      stroke={props.stroke}
      strokeWidth={0.1}
    />
  </SvgIcon>
);
